import request from '@/utils/request'
import { AxiosResult, ParamCodeParams, UserCustomerAreaListParams, UserCustomerAreaSaveParams } from '@/typings/common'
import type {
  PersonTimeZoneParams,
  PersonTimeZoneListResult,
  PersonTimeZoneEditParams
} from '@/typings/api/overseasSales'

/**
 * 查询所有按钮权限值
 */
export function buttonPermissions() {
  return request.post<AxiosResult, AxiosResult>('/base/api/users/getSitePermissions')
}
/**
 * 查询所有业务参数
 */
export function listByParamCodeAll() {
  return request.post<AxiosResult, AxiosResult>('/base/api/bizParam/all')
}
/**
 * 根据code集合查询业务参数
 */
export function listByParamCodes(data: ParamCodeParams) {
  return request.post<AxiosResult, AxiosResult>('/base/api/bizParam/listByParamCodes', data)
}
/**
 * 上传文件
 */
export function uploadFileApi(formData: FormData) {
  return request({
    url: '/base/resource/file/upload',
    data: formData,
    method: 'POST',
    headers: {
      'Content-type': 'multipart/form-data'
    }
  })
}
/**
 * 获取用户分页
 */
export function listByUsers(data: any) {
  return request.post<AxiosResult, AxiosResult>('/base/api/users/findByPage', data)
}
export function fetchUsersByWorkCode(data: any) {
  return request.post<AxiosResult, AxiosResult>('/base/api/users/list', data)
}
// 查询用户收藏菜单列表
export function favoriteMenu(params: object) {
  return request.get('/api/admin/v1/sys_out_user_menu_hide/gets', { params })
}

// 删除用户收藏菜单列表
export function favoriteMenuDelete(data: object) {
  return request.post('/api/admin/v1/sys_out_user_menu_hide/delete', data)
}

// 行政区域
export function adminArea(data: { appId: string }) {
  return request.post('/base/api/adminArea/all', data)
}
// 导出
export function exportList(data?: any) {
  return request.post('/base/api/export/save', data)
}

// 获取组织架构信息
export function getDeptInfo(data: { appId?: string; rootId?: string }) {
  return request.post('/base/api/users/getDeptInfo', data)
}
// 获取客户区域树
export function getCustomerArea(data: { appId: string }) {
  return request.post('/base/api/customerArea/all', data)
}
// 档次等级
export function getLevelOrGrade(data: { configType: number; appId: string }) {
  return request.post('/base/api/bizConfig/listByType', data)
}
// 查询员工客户区域
export function getuserCustomerAreaList(data: UserCustomerAreaListParams) {
  return request.post('/base/api/userCustomerArea/findByPage', data)
}
// 分配区域
export function userCustomerAreaSave(data: UserCustomerAreaSaveParams) {
  return request.post('/base/api/userCustomerArea/save', data)
}
// 签到记录
export function signInRecordListByCosId(data: { cosId: string; signInId?: number; startTime?: string, endTime?: string }) {
  return request.post<AxiosResult, AxiosResult>('/base/api/signInRecord/listByCosId', data)
}

/**
 * ************************************** 员工时区设置 **************************************
 */
//  获取员工时区列表数据
export function personTimeZoneList(data?: PersonTimeZoneParams) {
  return request.post<PersonTimeZoneListResult, PersonTimeZoneListResult>('/base/api/userTimeZone/findByPage', data)
}
// 新增员工时区设置
export function personTimeZoneCreate(data: PersonTimeZoneEditParams, custom?: any) {
  return request.post<AxiosResult, AxiosResult>('/base/api/userTimeZone/save', data, custom)
}
// 编辑员工时区设置
export function personTimeZoneEdit(data: PersonTimeZoneEditParams, custom?: any) {
  return request.post<AxiosResult, AxiosResult>('/base/api/userTimeZone/update', data, custom)
}
// 删除员工时区设置
export function personTimeZoneDel(data: { id: number }, custom?: any) {
  return request.post<AxiosResult, AxiosResult>('/base/api/userTimeZone/delete', data, custom)
}
export function addToFav(data: any) {
  return request.post<AxiosResult, AxiosResult>('/base/api/clueCustomer/collection/save', data)
}
export function cancelToFav(data: any) {
  return request.post<AxiosResult, AxiosResult>('/base/api/clueCustomer/collection/cancel', data)
}
export function parseCustomerInfo(data: any) {
  return request.post<AxiosResult, AxiosResult>('/base/api/text/parse', data)
}
